import { Category } from '@mui/icons-material';
import { Button, MenuItem, Typography, Menu } from '@mui/material';
import { useRef, useState } from 'react';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import { GridSortDirection } from '@mui/x-data-grid';

export type DataTableReportPreset = {
    name: string;
    cols: string[];
    sort: {
        by: string;
        order: GridSortDirection;
    };
};

export interface GridToolBarPresetSelectorProps {
    presets: DataTableReportPreset[];
    currentPreset: DataTableReportPreset | null;
    setCurrentPreset: React.Dispatch<
        React.SetStateAction<DataTableReportPreset | null>
    >;
}

export function GridToolBarPresetSelector({
    presets,
    currentPreset,
    setCurrentPreset,
}: GridToolBarPresetSelectorProps) {
    const [open, setOpen] = useState(false);

    const buttonRef = useRef<HTMLButtonElement>(null);

    const handleClose = (preset: DataTableReportPreset) => {
        setOpen(false);
        if (
            currentPreset === preset ||
            (currentPreset && currentPreset.name === 'None')
        ) {
            return setCurrentPreset(null);
        }
        setCurrentPreset(preset);
    };

    const selectNone = () => {
        return setCurrentPreset(null);
    };

    return (
        <>
            <Button
                size="small"
                startIcon={<Category />}
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onMouseUp={() => setOpen(!open)}
                ref={buttonRef}
                variant={currentPreset ? 'contained' : 'text'}
            >
                Reporting Presets
            </Button>
            <Menu
                onClose={() => setOpen(!open)}
                open={open}
                anchorEl={buttonRef.current}
            >
                <MenuItem key={'none'} onClick={() => selectNone()}>
                    {!currentPreset ? (
                        <RadioButtonCheckedIcon
                            fontSize="small"
                            color={'primary'}
                        />
                    ) : (
                        <RadioButtonUncheckedIcon fontSize="small" />
                    )}
                    None
                </MenuItem>
                {presets.map((preset) => (
                    <MenuItem
                        key={preset.name}
                        onClick={() => handleClose(preset)}
                    >
                        {currentPreset === preset ? (
                            <RadioButtonCheckedIcon
                                fontSize="small"
                                color={'primary'}
                            />
                        ) : (
                            <RadioButtonUncheckedIcon fontSize="small" />
                        )}
                        <Typography
                            color={
                                currentPreset === preset ? 'primary' : undefined
                            }
                        >
                            {preset.name}
                        </Typography>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
